module.exports = __webpack_public_path__ + "static/qvr_logo_teal-2df6c11734ea0ecf31ab4db4a4fbfdb5.svg";